import React, { useState } from "react";
import PageLayout from "../../PageLayout";
import FileUpload from "../../../common/FileUpload";
import { parse, ParseResult } from "../../../lib/csvUtils";
import CardImportResults from "./CardImportResults";
import { Paper } from "@mui/material";

const CardImport = () => {
  const [cardTableName, setCardTableName] = useState<string>("");
  const [parsedResult, setParsedResult] = useState<ParseResult | null>(null);

  const onFileChanged = (file: File) => {
    const fileReader = new FileReader();
    const fileName = file.name;
    const fileExtension = fileName.lastIndexOf(".");
    if (fileExtension) {
      setCardTableName(fileName.slice(0, fileExtension));
    } else {
      setCardTableName(fileName);
    }

    fileReader.onloadend = () => {
      if (fileReader.result) {
        const parsedResult = parse(fileReader.result as string);
        setParsedResult(parsedResult);
      }
    };
    fileReader.readAsText(file);
  };

  return (
    <PageLayout heading="Import Card Prefix">
      {!parsedResult ? (
        <Paper>
          <FileUpload
            multiple={false}
            onFileChanged={(file) => onFileChanged(file as File)}
          />
        </Paper>
      ) : (
        <CardImportResults
          cardTableName={cardTableName}
          parsedResult={parsedResult}
          onCancel={() => {
            setParsedResult(null);
            setCardTableName("");
          }}
        />
      )}
    </PageLayout>
  );
};

export default CardImport;
